<template>
  <div class="teaQuesAns">
    <Header :title="title"></Header>
    <van-tabs @change="onTabChange">
      <van-tab v-for="(item, index) in classify"
               :key="index"
               :title="item.name"></van-tab>
    </van-tabs>
    <Empty v-if="!newsList.length"
           :empty_type="{ name: '暂无数据' }"></Empty>
    <van-list v-else
              finished-text="没有更多了"
              ref="list"
              @load="getList()"
              class="lists"
              :showText="newsList.length > 0">
      <ul class="news-content">
        <li tag="li"
            v-for="(item, index) in newsList"
            :key="index"
            @click="toDetail(item)">
          <div class="content_item">
            <div class="item_info">
              <img class="avatar"
                   :src="item.avatar" />
              <div class="title">
                <span class="name">{{item.nickname}}</span>
                <span class="desc">{{item.created_at}}</span>
              </div>
            </div>
            <div v-if="url=='jaskList'">
              <div class="item_content">
                <p class="que_title">{{item.title}}</p>
                <div class="img_items">
                  <div class="img_item"
                       v-if="item.images !==''">
                    <van-image-preview v-model="item.showPreview"
                                       :images="setImgArr(item)">
                    </van-image-preview>
                    <img :src="item.images.split(',')[0]"
                         @click.stop="showPreviewImg(item)">
                  </div>
                  <p class="ans_conten"
                     :class="item.images !==''?'ans_conten_img':''">{{item.content}}</p>
                </div>
              </div>
              <div class="btns">
                <span class="watch_icon"><i></i> {{item.browse_number}}</span>
                <span class="zan_icon"
                      @click.stop="like(item)"
                      :class="item.is_like==1?'is_like':''"><i></i> {{item.like_number}}</span>
                <span class="common_icon"><i></i> {{item.answer_number}}</span>
              </div>
            </div>
            <div v-if="url=='caskList'">
              <p class="course_ques">{{item.nickname}}在
                <span class="course_title">{{item.course_title}}</span>
                中提出了问题：{{item.content}}</p>
            </div>
            <div v-if="url=='zaskList'">
              <p class="course_ques">{{item.nickname}}在
                <span class="course_title">{{item.ques_stem_text}}</span>
                中提出了问题：{{item.content}}</p>
            </div>
          </div>
        </li>
      </ul>
    </van-list>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Empty from "@/components/Empty";
import List from "@/components/que_answers/QueItem";
import CourseQuesItem from "@/components/que_answers/CourseQuesItem"
export default {
  name: "teaQuesAns",
  components: {
    Header,
    Empty,
    List,
    CourseQuesItem
  },
  data () {
    return {
      title: {
        name: "我的回答"
      },
      classify: [], // 资讯类别
      newsList: [], // 资讯列表
      params: {
        classify_id: ""
      },
      type: true,
      page: 0,
      url: 'jaskList'
    };
  },
  created () {
    this.classify = [
      { id: 'jaskList', name: "问答", parent_id: 0 },
      { id: 'caskList', name: "课程问答", parent_id: 0 },
      { id: 'zaskList', name: "题目问答", parent_id: 0 }
    ];
    this.getList();
  },
  methods: {
    onTabChange (index) {
      if (this.url != this.classify[index].id) {
        this.url = this.classify[index].id;
        this.page = 0;
        this.newsList = [];
        this.getList();
      }
    },
    onGetdata (data) {
      this.newsList = data.List;
    },
    like (item) {
      let params = { ask_id: item.id, comment_id: 0, user_type: 1 }
      this.$pub.clickLikeTea(params).then((res) => {
        if (item.is_like == 0) {
          item.is_like = 1;
          item.like_number++;
        } else {
          item.is_like = 0;
          item.like_number--;
        }
      });
    },
    showPreviewImg (item) {
      this.$set(item, 'showPreview', true)
    },
    setImgArr (item) {
      let arrImg = [];
      let arr = item.images.split(',');
      arrImg.push(arr[0])
      return arrImg;
    },
    toDetail (item) {
      let type = 1;
      let name = 'TeaQuesDetail';
      let query = { id: item.id };
      if (this.url == 'caskList') {//单独的问答或课程问答
        query.answer_id = item.answer_id;
      } else if (this.url == 'zaskList') {//题目问答
        query.answer_id = item.answer_id;
        name = 'TeaQuestionDetail'
      }
      this.$router.push({ name: name, query: query })
    },
    getList () {
      this.page++;
      this.$http.get(`/api/lector/teacher/myAnswer/${this.url}`, { page: this.page }).then(res => {
        this.newsList = res.list.concat(this.newsList);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.teaQuesAns {
  @extend %default-bg;
  background-color: #fff;
  .top_right_icon {
    text-align: right;
    .icon_span {
      font-size: 22px;
      color: #999;
      line-height: 22px;
      margin: 0 10px;
      display: inline-block;
    }
    .number {
      padding: 0 0 0 34px;
      background: url("~@/assets/images/icon-eye.png") left center no-repeat;
      background-size: 25px 17px;
    }
  }
  .detail {
    @include lines-eps(2);
    font-size: 24px;
    color: #7c7c7c;
    line-height: 33px;
    padding: 0 28px 0 105px;
    span {
      color: $theme_color;
    }
  }
  .news-content {
    padding: 30px 20px;
    li {
      padding: 20px;
      background: #fff;
      border-bottom: 1px solid #f6f6f6;
      &:nth-last-child(1) {
        border: none;
      }
      .item_content {
        margin-left: 66px;
        .que_title {
          font-size: 26px;
          color: #333333;
          line-height: 32px;
          @include lines-eps(2);
        }
        .ans_conten {
          float: left;
          color: #7c7c7c;
          font-size: 24px;
          line-height: 33px;
          @include lines-eps(3);
        }
        .ans_conten_img {
          width: calc(100% - 170px);
          margin-left: 10px;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
      .avatar {
        display: block;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        flex: none;
        margin-right: 16px;
        float: left;
      }
      .img_items {
        margin: 20px 0;
        // display: flex;
        // justify-content: space-between;
        .img_item {
          width: 160px;
          height: 160px;
          float: left;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .btns {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 64px;
        height: 62px;
        span {
          font-size: 24px;
          color: #999999;
          height: 60px;
          line-height: 60px;
        }
        span i {
          display: inline-block;
          width: 28px;
          height: 16px;
          background-image: url("~@/assets/images/watch_icon.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          vertical-align: middle;
        }
        .common_icon i {
          width: 21px;
          height: 21px;
          background-image: url("~@/assets/images/common@2x.png");
        }
        .zan_icon i {
          width: 23px;
          height: 21px;
          background-image: url("~@/assets/images/zan@2x.png");
        }
        // .zan_icon.is_like i {
        //   background-image: url("~@/assets/theme-img/icon-star.png");
        // }
      }
      .title {
        float: left;
        padding-top: 4px;
      }
      & .content_item > div {
        overflow: hidden;
        .name {
          @include eps;
          font-size: 28px;
          font-weight: 500;
          color: #333;
          display: block;
        }
        .desc {
          @include eps;
          font-size: 22px;
          display: inline-block;
          margin-top: -8px;
          color: #999;
        }
        .top_right_icon {
          float: right;
          margin-top: -10px;
          .icon_span {
            font-size: 22px;
            color: #999;
            line-height: 22px;
            margin: 0 10px;
            display: inline-block;
          }
          .number {
            padding: 0 0 0 34px;
            background: url("~@/assets/images/icon-eye.png") left center
              no-repeat;
            background-size: 25px 17px;
          }
        }
      }
      .course_ques {
        font-size: 24px;
        color: #7c7c7c;
        padding-left: 60px;
        line-height: 33px;
        .course_title {
          color: $theme_color;
        }
      }
    }
  }
  .emptyData {
    margin-top: 100px;
  }
}
</style>
